import React, { useState } from 'react';
import { Card, CardBody, Button, Input } from 'reactstrap';
import { ReactComponent as SearchIcon } from "../../../../../../assets/img/svg/SearchIconGray.svg"
//import { menuItems } from './constant';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { Popover } from '@mui/material';
import { customStyle } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant';
const Sidebar = ({ selectedTab, setSelectedTab, handleTabChange, menuItems, fieldMap = {} }) => {

    const [collapsed, setCollapsed] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchbar, setSearchbar] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null);
    const [suggestions, setSuggestions] = useState([]);


const resolvedFieldMap =
  typeof fieldMap === "function" ? fieldMap() : fieldMap;

const searchIndex = Object.entries(resolvedFieldMap || {}).flatMap(
  ([tabKey, fields]) =>
    (fields || []).map(field => ({
      tabKey,
      fieldLabel: field?.label ?? field?.headerName
    }))
);


    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (value) {
            const filtered = searchIndex.filter(item =>
                item.fieldLabel.toLowerCase().includes(value.toLowerCase())
            );

            const filteredItems = menuItems.filter(item =>
                item.label.toLowerCase().includes(value.toLowerCase())
            ) ?? [];


            setSuggestions([...filteredItems, ...filtered]);
            setAnchorEl(e.currentTarget);
        } else {
            setSuggestions([]);
            setAnchorEl(null);
        }
    };


    const handleSuggestionClick = (suggestion) => {
        if (suggestion.label && suggestion.key) {
            // It's a tab
            handleTabChange(suggestion);
            setSearchText(suggestion.label);
        } else if (suggestion.fieldLabel && suggestion.tabKey) {
            // It's a field
            const tab = tabMap[suggestion.tabKey];
            if (tab) handleTabChange(tab);
            setSearchText(suggestion.fieldLabel);
        }

        setAnchorEl(null);
    };



    const tabMap = menuItems.reduce((acc, item) => {
        acc[item.key] = item;
        return acc;
    }, {});


    return (
        <Card
            className="d-flex flex-column  ml-3 mr-3"
            style={{
                width: collapsed ? '80px' : '30%',
                transition: 'width 0.3s ease',
                borderRadius: '16px',
                borderRight: '1px solid #dee2e6',
                overflowY: 'auto'
            }}
        >
            <CardBody className="p-3 d-flex flex-column"
                style={{
                    overflowY: 'auto',
                    // flexGrow: 1,
                }}>

                <div
                    className="d-flex align-items-center justify-content-between color-grey-50"
                    style={{
                        marginBottom: '16px',
                        flexWrap: 'nowrap',
                        gap: '8px',  // space between SETTINGS and right side controls
                    }}
                >
                    {!collapsed && (
                        <span style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                            SETTINGS
                        </span>
                    )}

                    <div
                        className="d-flex align-items-center"
                        style={{
                            gap: '6px',
                            flexWrap: 'nowrap',
                            overflow: 'hidden',
                        }}
                    >
                        {(collapsed || !searchbar) ? (
                            <span className="cursor" onClick={() => setSearchbar(true)}>
                                <SearchIcon />
                            </span>
                        ) : (
                            <>
                                <div style={{ flexShrink: 1, minWidth: 0 }}>
                                    <AInput
                                        style={{
                                            height: '31px',
                                            width: '100%',
                                            maxWidth: '201px',
                                            paddingLeft: '26px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                        value={searchText}
                                        handler={(value, e) => handleSearchChange(e)}
                                        crossIcon={true}
                                        crossHandler={() => setSearchText('')}
                                        customIconStyle={{ ...customStyle, top: '2px' }}
                                        customIcon={<SearchIcon />}
                                    />
                                </div>

                                <Popover
                                    open={Boolean(anchorEl)}
                                    anchorEl={anchorEl}
                                    onClose={() => setAnchorEl(null)}
                                    disableAutoFocus
                                    disableEnforceFocus
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    sx={{ maxHeight: 300 }}
                                >
                                    <div className="d-flex flex-column" style={{ gap: '16px', padding: '16px 20px' }}>
                                        {suggestions.length > 0 ? suggestions.map((suggestion, idx) => (
                                            <React.Fragment key={idx}>
                                                <div onClick={() => handleSuggestionClick(suggestion)} className='cursor d-flex justify-content-between align-items-center'>
                                                    <div>
                                                        <div className='regular-bolder color-grey-80'>
                                                            {suggestion?.fieldLabel ?? suggestion?.label}
                                                        </div>
                                                        <div className='regular-small color-grey-50'>
                                                            {tabMap?.[suggestion?.tabKey]?.label}
                                                        </div>
                                                    </div>
                                                    <div className='large-text ml-1'> {'>'} </div>
                                                </div>
                                                {idx !== suggestions.length - 1 && (
                                                    <div className='mx-0' style={{ borderBottom: "1px solid #E2E2E2" }}></div>
                                                )}
                                            </React.Fragment>
                                        )) : (
                                            <div className='regular-small color-grey-50'>No result found</div>
                                        )}
                                    </div>
                                </Popover>
                            </>
                        )}

                        <div
                            className="cursor d-flex align-items-center justify-content-center"
                            onClick={() => setCollapsed(!collapsed)}
                            style={{
                                width: '30px',
                                height: '32px',
                                minWidth: '16px',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                userSelect: 'none',
                            }}
                        >
                            {collapsed ? '<>' : '><'}
                        </div>

                    </div>
                </div>



                {/* Menu Items */}
                <nav className="d-flex flex-column ">
                    {(menuItems).map(item => (
                        <div
                            key={item.id}
                            onClick={() => {
                                handleTabChange(item)
                                setSearchText(item.label);
                            }}
                            style={{
                                cursor: 'pointer',
                                backgroundColor: selectedTab?.id === item?.id ? '#f8f9fa' : 'transparent',
                                borderRadius: '8px',
                                marginBottom: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px',
                                gap: '16px',
                                minHeight: '52px',
                                minWidth:'52px'
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '36px',
                                    height: '36px',
                                    minWidth: '36px',
                                    borderRadius: '8px',
                                    border: '1px solid #E2E2E2',
                                    backgroundColor: selectedTab?.id === item?.id ? '#f8f9fa' : 'transparent',
                                }}
                            >
                                {item.icon}
                            </div>

                            {!collapsed && (
                                <div style={{ overflow: 'hidden' }}>
                                    <div
                                        className={
                                            selectedTab?.id === item?.id
                                                ? 'regular-large-bold color-grey-80'
                                                : 'regular-large color-grey-80'
                                        }
                                    >
                                        {item.label}
                                    </div>
                                    <div className="regular-small color-grey-50">{item?.desc}</div>
                                </div>
                            )}
                        </div>


                    ))}
                </nav>
            </CardBody>
        </Card>
    );
}

export default Sidebar
